import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BeneficiariComponent } from './beneficiari.component';
import { BeneficiariDetaliiComponent } from './beneficiari-detalii/beneficiari-detalii.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { DataTablesModule } from 'angular-datatables';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { AddBeneficiarComponent } from './add-beneficiar/add-beneficiar.component';
import { SubsemnatComponent } from './beneficiari-detalii/subsemnat/subsemnat.component';
import { EditSubsemnatComponent } from './beneficiari-detalii/subsemnat/edit-subsemnat/edit-subsemnat.component';
import { MesagerieComponent } from './beneficiari-detalii/mesagerie/mesagerie.component';
import { IstoricComponent } from './beneficiari-detalii/istoric/istoric.component';
import { AddLocationComponent } from './beneficiari-detalii/subsemnat/add-location/add-location.component';
import { EditLocationComponent } from './beneficiari-detalii/subsemnat/edit-location/edit-location.component';
import { ViewIstoricLocalizareComponent } from './beneficiari-detalii/subsemnat/view-istoric-localizare/view-istoric-localizare.component';
import { AddRelationshipComponent } from './beneficiari-detalii/subsemnat/add-relationship/add-relationship.component';
import { EditRelationshipComponent } from './beneficiari-detalii/subsemnat/edit-relationship/edit-relationship.component';
import { ViewIstoricRelationshipComponent } from './beneficiari-detalii/subsemnat/view-istoric-relationship/view-istoric-relationship.component';
import { DocumenteComponent } from './beneficiari-detalii/documente/documente.component';
import { ViewIstoricSubsemnatComponent } from './beneficiari-detalii/subsemnat/view-istoric-subsemnat/view-istoric-subsemnat.component';
import { ViewDocumentComponent } from './beneficiari-detalii/documente/view-document/view-document.component';
import { DocumenteIndocComponent } from './beneficiari-detalii/documente-indoc/documente-indoc.component';


@NgModule({
    declarations: [
        BeneficiariComponent,
        BeneficiariDetaliiComponent,
        AddBeneficiarComponent,
        SubsemnatComponent,
        EditSubsemnatComponent,
        MesagerieComponent,
        IstoricComponent,
        AddLocationComponent,
        EditLocationComponent,
        ViewIstoricLocalizareComponent,
        AddRelationshipComponent,
        EditRelationshipComponent,
        ViewIstoricRelationshipComponent,
        DocumenteComponent,
        ViewIstoricSubsemnatComponent,
        ViewDocumentComponent,
        DocumenteIndocComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        DataTablesModule,
        PipesModule
    ],
    exports: [BeneficiariComponent],
})
export class BeneficiariModule { }
